/**
 * WGS84 ellipsoid major axis (in meters)
 */
export const ELLIPSOID_MAJOR_AXIS = 6378137;


/**
 * WGS84 ellipsoid minor axis (in meters)
 */
export const ELLIPSOID_MINOR_AXIS = 6356752.314245;


/**
 * WGS84 ellipsoid flattening (in meters)
 */
export const ELLIPSOID_FLATTENING = 1 / 298.257223563;
